import { render, staticRenderFns } from "./NewFileRequestDialogFinish.vue?vue&type=template&id=6ef16afe&scoped=true"
import script from "./NewFileRequestDialogFinish.vue?vue&type=script&lang=ts"
export * from "./NewFileRequestDialogFinish.vue?vue&type=script&lang=ts"
import style0 from "./NewFileRequestDialogFinish.vue?vue&type=style&index=0&id=6ef16afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef16afe",
  null
  
)

export default component.exports